import { encodedStringRecordParser } from '../inboundParsers';
import { playerIdNameParser } from './utils/playerInboundUtils';
export const SHOW_PLAYER_DEBUG_INFO_PAYLOAD_DEFINITION = {
    definitionParts: [
        { name: 'playerIdName', parser: playerIdNameParser },
        { name: 'fields', parser: encodedStringRecordParser }
    ]
};
